import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---helpers
import { globalLoader, MEDIA } from '@/helpers/variables';
import { PRODUCTS_ORDER_KEY } from '@/helpers';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductsBlock from '@/components/products/ProductsBlock/index.vue';
import ProductsFilters from '@/components/products/ProductsFilter/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'Outlet',
  mixins: [dynamicHead],
  components: {
    ProductsFilters,
    ProductsBlock,
    BreadcrumbsSimple,
    Pagination
  },
  data() {
    return {
      MEDIA,
      outletData: null,
      outletProducts: [],
      outletProductsMeta: null,
      isOutletProductsLoading: false
    };
  },
  created() {
    globalLoader(true);
    this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      appSize: 'app/size',
      filters: 'filters/filters'
    }),
    breadcrumbs() {
      return [{ title: this.$t('catalog'), route: { name: 'products' } }];
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.outletProducts;
      }

      const favourites = _.map(this.favourites, 'productId');
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      return _.map(this.outletProducts, markAsSelected);
    }
  },
  methods: {
    ...mapActions({
      getFilters: 'filters/GET_FILTERS',
      getOutletProducts: 'outlet/GET_OUTLET_PRODUCTS',
      getPage: 'staticPages/GET_PAGE'
    }),
    async _getProducts() {
      this.isOutletProductsLoading = true;
      let { orderby, filters } = this.$route.query;
      let { page } = this.$route.params;

      let params = {
        page: page ? Number(page) : 1,
        sort_filter_type: orderby ? orderby : PRODUCTS_ORDER_KEY.BESTSELLERS
      };

      if (filters) {
        let categories = filters.split('|').reduce((acc, categoryString) => {
          let idsArray = categoryString.slice(categoryString.indexOf('[') + 1, categoryString.indexOf(']')).split('-');
          return [...acc, ...idsArray];
        }, []);
        params = { ...params, categories: categories.join(',') };
      }

      return this.getOutletProducts(params)
        .then((result) => {
          this.outletProducts = result.data;
          this.outletProductsMeta = result.meta;
        })
        .finally(() => {
          this.isOutletProductsLoading = false;
        });
    },

    async _loadContent() {
      let promiseCollection = [];

      promiseCollection.push(this.getFilters());
      promiseCollection.push(this._getProducts());
      promiseCollection.push(
        this.getPage('outlet').then((data) => {
          this.outletData = data;
          this._setMetaParams();
        })
      );
      await Promise.all(promiseCollection).then();

      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.outletData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
